module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-20"
  }, [_c('li', {
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.step == 0) ? _c('div', {}, [_c('p', [_vm._v("Para começar informe a validade deste vale-pedágio e a rota a ser percorrida:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-grey"
  }, [_c('p', {
    staticClass: "bold no-margin"
  }, [_vm._v("Validade")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row-dates"
  }, [_c('div', {
    staticClass: "form-group col-6"
  }, [_c('label', {
    attrs: {
      "for": "dataInicioViagem"
    }
  }, [_vm._v("Início da viagem")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInicioViagem),
      expression: "dataInicioViagem"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "dataInicioViagem",
      "type": "datetime-local",
      "min": _vm.minDate,
      "max": _vm.dataFimViagem
    },
    domProps: {
      "value": (_vm.dataInicioViagem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInicioViagem = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group  col-6"
  }, [_c('label', {
    attrs: {
      "for": "dataFimViagem"
    }
  }, [_vm._v("Fim da viagem")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataFimViagem),
      expression: "dataFimViagem"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "dataFimViagem",
      "type": "datetime-local",
      "min": _vm.dataInicioViagem,
      "max": _vm.maxDate
    },
    domProps: {
      "value": (_vm.dataFimViagem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataFimViagem = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('route-resume', {
    attrs: {
      "routeIdSelected": _vm.routeSelected
    },
    model: {
      value: (_vm.routeSelected),
      callback: function($$v) {
        _vm.routeSelected = $$v
      },
      expression: "routeSelected"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "margin-b20"
  }, [_c('div', {
    staticClass: "row margin-b30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "search-box inline"
  }, [_c('p', {
    staticClass: "bold text-center no-margin"
  }, [_vm._v("Informe a placa do veículo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.plate),
      expression: "plate",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-plate",
      rawName: "v-mask-plate"
    }],
    staticClass: "form-control search text-center bold upper",
    attrs: {
      "type": "text",
      "name": "plate",
      "data-vv-validate-on": "blur",
      "placeholder": "Ex: ABC-0000",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.findPlate.apply(null, arguments)
      },
      "change": function($event) {
        _vm.plate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-box inline"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.findPlate
    }
  }, [_c('i', {
    staticClass: "icon-search align-icon-left-white"
  }), _vm._v("\n                Buscar\n              ")])])])]), _vm._v(" "), (_vm.vehicle) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-grey"
  }, [_c('p', {
    staticClass: "bold no-margin"
  }, [_vm._v("Dados do veículo")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "brandName",
      "readonly": ""
    },
    domProps: {
      "value": _vm.vehicle.brandName + ' ' + _vm.vehicle.nodelName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "razao",
      "readonly": ""
    },
    domProps: {
      "value": _vm.vehicle.tagSerialNumber
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('dropdown', {
    staticClass: "dropdown-lg",
    attrs: {
      "options": _vm.axes,
      "value": _vm.vehicle.category,
      "fieldValue": "category_artesp_id"
    },
    model: {
      value: (_vm.axesId),
      callback: function($$v) {
        _vm.axesId = $$v
      },
      expression: "axesId"
    }
  })], 1)]), _vm._v(" "), (!_vm.enableRNTRC) ? _c('p', {
    staticClass: "bold margin-t30 margin-b0"
  }, [_vm._v("Dados do transportador")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.vehicle.companyName && !_vm.enableRNTRC) ? _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [(_vm.nomeTransportador) ? _c('input', {
    staticClass: "form-control small upper",
    attrs: {
      "type": "text",
      "name": "razao",
      "readonly": ""
    },
    domProps: {
      "value": _vm.nomeTransportador
    }
  }) : _c('input', {
    staticClass: "form-control small upper",
    attrs: {
      "type": "text",
      "name": "razao",
      "readonly": ""
    },
    domProps: {
      "value": _vm.vehicle.companyName
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.companyTradeName && !_vm.enableRNTRC) ? _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small upper",
    attrs: {
      "type": "text",
      "name": "razao",
      "readonly": ""
    },
    domProps: {
      "value": _vm.vehicle.companyTradeName
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.companyTradeName && !_vm.enableRNTRC) ? _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "razao",
      "readonly": ""
    },
    domProps: {
      "value": _vm.documentoTransportador || _vm.vehicle.taxIdNumber
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.personName && !_vm.enableRNTRC) ? _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [(_vm.nomeTransportador) ? _c('input', {
    staticClass: "form-control small upper",
    attrs: {
      "type": "text",
      "name": "cpf",
      "readonly": ""
    },
    domProps: {
      "value": _vm.nomeTransportador
    }
  }) : _c('input', {
    staticClass: "form-control small upper",
    attrs: {
      "type": "text",
      "name": "cpf",
      "readonly": ""
    },
    domProps: {
      "value": _vm.vehicle.personName + ' ' + _vm.vehicle.personLastName
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.vehicle.personName && !_vm.enableRNTRC) ? _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "cpf",
      "readonly": ""
    },
    domProps: {
      "value": _vm.documentoTransportador || _vm.vehicle.taxIdNumber
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.enableRNTRC) ? _c('div', {
    staticClass: "form-group input-box-control"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "razao",
      "readonly": ""
    },
    domProps: {
      "value": _vm.vehicle.rntrc
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.rntrcRejected && !_vm.enableRNTRC) ? _c('div', {
    staticClass: "rntrc-exception"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createException),
      expression: "createException"
    }],
    staticClass: "rntrc-exception-check",
    attrs: {
      "id": "createException",
      "type": "checkbox",
      "name": "createException"
    },
    domProps: {
      "checked": Array.isArray(_vm.createException) ? _vm._i(_vm.createException, null) > -1 : (_vm.createException)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createException,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.createException = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.createException = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.createException = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "rntrc-exception-label",
    attrs: {
      "for": "createException"
    }
  }, [_vm._v("Criar exceção")]), _vm._v(" "), _c('p', {
    staticClass: "rntrc-exception-hint"
  }, [_vm._v("Ao marcar esta opção, você declara ser responsável pela veracidade dos dados e autoriza a emissão sem validação ANTT.")]), _vm._v(" "), (!_vm.createException) ? _c('p', {
    staticClass: "rntrc-exception-required"
  }, [_vm._v("Para continuar, selecione uma ação válida.")]) : _c('p', {
    staticClass: "rntrc-exception-success"
  }, [_vm._v("A exceção será criada no momento da emissão do Vale-Pedágio.")])]) : _vm._e(), _vm._v(" "), (!_vm.enableRNTRC) ? _c('hr', {
    staticStyle: {
      "margin": "20px 0"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.enableRNTRC) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "margin": "15px 0"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-auto",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.showRNTRC
    }
  }, [_vm._v("\n                  Alterar Transportador\n                ")])]) : _vm._e()])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('div', {
    staticClass: "form-box margin-b20 padding-b10"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Resumo e Confirmação do Pedido")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 user-data-resume"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.emissor) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.user.taxIdNumber)) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 user-data-resume"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.transportador) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.documentoTransportador) ? _c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.documentoTransportador)) + " ")]) : _c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.vehicle.taxIdNumber)) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 user-data-resume"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.routeSelected.name) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.routeOrigin) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.routeDestination) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(26), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataInicioViagem)) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.dataFimViagem)) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 user-data-resume"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_c('span', {
    staticClass: "plate"
  }, [_vm._v(_vm._s(_vm.vehicle.plate))]), _vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(29), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.category) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.vehicle.brandName) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.vehicle.nodelName) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.vehicle.tagSerialNumber) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Rota Detalhada e Valores")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(33), _vm._v(" "), _c('tbody', _vm._l((_vm.priceTolls.tolls), function(p, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.priceTolls.totalValue)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Informações opcionais")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "doc-box text-center"
  }, [_c('div', {
    staticClass: "inline text-right margin-b10"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.motorista),
      expression: "motorista"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.motorista)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motorista = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline text-left"
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.externalId),
      expression: "externalId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "id": "externalId"
    },
    domProps: {
      "value": (_vm.externalId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.externalId = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "doc-box text-center"
  }, [_c('div', {
    staticClass: "inline text-right margin-b10"
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campo1),
      expression: "campo1"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.campo1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campo1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline text-left"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campo2),
      expression: "campo2"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.campo2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campo2 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "doc-box text-center"
  }, [_c('div', {
    staticClass: "inline text-right margin-b10"
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campo3),
      expression: "campo3"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.campo3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campo3 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline text-left"
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campo4),
      expression: "campo4"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.campo4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campo4 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "doc-box text-center"
  }, [_c('div', {
    staticClass: "inline text-right margin-b10"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campo5),
      expression: "campo5"
    }],
    staticClass: "form-control search",
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.campo5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campo5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(41)])])])])]) : _vm._e()]), _vm._v(" "), (_vm.enableRNTRC) ? _c('div', {
    staticClass: "col-xs-12 margin-b20"
  }, [_c('div', {
    staticClass: "content-grey"
  }, [_c('p', {
    staticClass: "bold margin-t10 margin-b0"
  }, [_vm._v("Dados do transportador")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control margin-t20"
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rntrcOwnerName),
      expression: "rntrcOwnerName"
    }],
    staticClass: "form-control small upper",
    attrs: {
      "autofocus": "autofocus",
      "type": "text",
      "name": "rntrcOwnerName"
    },
    domProps: {
      "value": (_vm.rntrcOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rntrcOwnerName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control",
    class: {
      'has-error': _vm.errors.has('rntrcDocument')
    }
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.rntrcDocument),
      expression: "rntrcDocument",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj'),
      expression: "'required|cpfCnpj'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "rntrcDocument",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.rntrcDocument)
    },
    on: {
      "change": function($event) {
        _vm.rntrcDocument = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('rntrcDocument')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "margin-top": "15px",
      "gap": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-back",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.cancelRNTRC
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.validateDocument
    }
  }, [_vm._v("\n              Validar\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.msgError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b20"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.msgError))])])]) : _vm._e()])]), _vm._v(" "), (_vm.showForceTransfer) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forceTransfer),
      expression: "forceTransfer"
    }],
    staticClass: "check-terms",
    attrs: {
      "id": "force",
      "type": "checkbox",
      "name": "forceTransfer"
    },
    domProps: {
      "checked": Array.isArray(_vm.forceTransfer) ? _vm._i(_vm.forceTransfer, null) > -1 : (_vm.forceTransfer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forceTransfer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forceTransfer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forceTransfer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forceTransfer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "force"
    }
  }, [_vm._v("\n      A emissão do VPO se dará quando normalizado a falha de comunicação. O valor de recarga será confirmado de modo automático, deseja confirmar?\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "margin-t10"
  }, [_c('div', {
    staticClass: "back-button-box"
  }, [(_vm.step > 0) ? _c('button', {
    staticClass: "btn btn-back",
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n            Voltar\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-cancel align-icon-left-white"
  }), _vm._v("\n            Cancelar\n          ")]), _vm._v(" "), (_vm.step < 2) ? _c('button', {
    staticClass: "btn btn-purple add",
    attrs: {
      "disabled": _vm.enableRNTRC || (_vm.rntrcRejected && !_vm.createException)
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n            Avançar\n            "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('button', {
    staticClass: "btn btn-success end",
    on: {
      "click": function($event) {
        return _vm.doRequest()
      }
    }
  }, [_vm._v("\n            Confirmar Emissão\n            "), _c('i', {
    staticClass: "icon-tick align-icon-right-white"
  })]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title title-plans"
  }, [_vm._v("Vale-pedágio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-route-chrono"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 1")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Data e Rota")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-truck"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 2")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Veículo e Transportador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Etapa 3")]), _vm._v(" "), _c('small', {
    staticClass: "no-margin"
  }, [_vm._v("Resumo e confirmação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "A validade é o período em dias que o transportador terá para realizar a viagem."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Marca e Modelo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("N° TAG:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Categoria:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Razão Social:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Nome Fantasia:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("CNPJ:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("RNTRC:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Dados dos Envolvidos")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Emissor:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("CNPJ Emissor:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Transportador:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("CPF/CNPJ Transportador:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Viagem e Veículo")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Rota:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Origem:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Destino:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Data Início VP:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Data Expiração VP:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Placa Veículo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Categoria Veículo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Marca:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("Modelo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 text-right"
  }, [_c('p', [_vm._v("N° TAG:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("PRAÇAS DE PEDÁGIO")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("VALOR(R$)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome do motorista")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Identificador Vp (cliente):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Campo 1:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Campo 2:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Campo 3:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Campo 4:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Campo 5:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline text-left"
  }, [_c('div', {
    staticClass: "label-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box doc"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Nome/Razão social:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("CPF/CNPJ do RNTRC:")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-d82f399c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/toll-ticket/toll-ticket.vue
// module id = 2218
// module chunks = 1